// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__NW5GH","underlay":"modal_underlay__PzMFD","open":"modal_open__33r6Y","content":"modal_content__yfIrs","close":"modal_close__TMdIf"};